import React, { useEffect, useState } from "react";
import Style from "../../style/eventcity.module.scss";

const EventCity = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    fetch("/data/event.json")
      .then((value) => value.json())
      .then((res) => setData(res.events));
  }, []);

  const countByCity = (city: string) =>
    data.filter((item: any) => item.venue.city === city).length;

  const cityData = Array.from(
    new Map(data.map((item: any) => [item.venue.city, item])).values()
  ).slice(0, 12);

  const cityImageMap: { [key: number]: string } = [
    "https://cdn-icons-png.flaticon.com/512/684/684908.png",
    "https://cdn-icons-png.flaticon.com/512/619/619034.png",
    "https://cdn-icons-png.flaticon.com/512/1046/1046857.png",
    "https://cdn-icons-png.flaticon.com/512/235/235861.png",
    "https://cdn-icons-png.flaticon.com/512/684/684908.png",
    "https://cdn-icons-png.flaticon.com/512/1995/1995574.png",
    "https://cdn-icons-png.flaticon.com/512/2784/2784403.png",
    "https://cdn-icons-png.flaticon.com/512/684/684920.png",
    "https://cdn-icons-png.flaticon.com/512/684/684914.png",
    "https://cdn-icons-png.flaticon.com/512/684/684921.png",
    "https://cdn-icons-png.flaticon.com/512/684/684907.png",
    "https://cdn-icons-png.flaticon.com/512/684/684902.png",
  ];

  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <div className={Style.title}>
          <h2>Browse Events By City</h2>
        </div>
        <div className={Style.content}>
          <ul>
            {cityData.map((item: any, index: any) => (
              <li key={item.venue.city}>
                <a
                  href={`/event/city/${item.venue.city
                    .toLowerCase()
                    .replaceAll(" ", "-")}`}
                >
                  <img src={cityImageMap[index]} alt={item.venue.city} />
                  <span>{item.venue.city}</span>
                  <strong>{countByCity(item.venue.city)} Events</strong>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EventCity;
